import { Configuration, LogLevel } from '@azure/msal-browser';
import { environment } from "./environments/environment";

export const msalConfig: Configuration = {
  auth: {
    clientId: environment.msalClientId, // Application (client) ID from Azure portal
    authority: environment.msalAuthority, // Directory (tenant) ID from Azure portal
    redirectUri: environment.appUrl,
    postLogoutRedirectUri: environment.appUrl
  },
  cache: {
    cacheLocation: 'localStorage'
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;

          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      },
      logLevel: LogLevel.Info
    }
  }
};
